import React from "react";
import * as Sentry from "@sentry/react";

interface Props {
  tabName: string;
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error(`[ErrorBoundary] ${this.props.tabName} tab crashed:`, error, info.componentStack);
    Sentry.captureException(error, {
      extra: { tab: this.props.tabName, componentStack: info.componentStack },
    });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          minHeight: 300, gap: 16, padding: 40, textAlign: "center",
          fontFamily: "'Inter','Avenir Next','Century Gothic',sans-serif",
        }}>
          <div style={{ fontSize: 32, opacity: 0.4 }}>⚠</div>
          <div style={{ fontSize: 14, fontWeight: 600, color: "#e05050" }}>
            Something went wrong in the {this.props.tabName} tab
          </div>
          <div style={{ fontSize: 12, color: "#888", maxWidth: 420, lineHeight: 1.6 }}>
            {this.state.error.message}
          </div>
          <button
            onClick={() => this.setState({ error: null })}
            style={{
              marginTop: 8, padding: "8px 20px", background: "#3a7bd5", color: "#fff",
              border: "none", borderRadius: 6, cursor: "pointer", fontSize: 13,
              fontFamily: "inherit",
            }}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
